import { useLoadedStrategyMetadata } from '@/src/features/procurement-and-markets/load-planning/hooks/LoadPlanning.hooks'
import { LoadPlanningConsumptionVisuals } from '@/src/features/procurement-and-markets/load-planning/load-planning-graph/LoadPlanningConsumptionVisuals'
import { Spinner } from '@chakra-ui/react'
import { FlexCol } from '@components'
import { LoadPlanningKpiBoxes } from '@features/procurement-and-markets/load-planning/LoadPlanningKpiBoxes'

export const LoadPlanningConsumption = () => {
  const { data: strategyMetadata } = useLoadedStrategyMetadata()
  return (
    <FlexCol gap={4}>
      <LoadPlanningKpiBoxes />
      {strategyMetadata ? (
        <LoadPlanningConsumptionVisuals
          key={`load-planning-consumption-visual-${strategyMetadata?.year}-${strategyMetadata?.energyType}`}
        />
      ) : (
        <Spinner />
      )}
    </FlexCol>
  )
}
